// @flow
import React, { Component } from 'react';
import { MdClose, MdLink, MdShare } from 'react-icons/md';
import { FaFacebookSquare, FaTwitter } from 'react-icons/fa';
import { copyText, shareFacebook, shareTwitter } from 'lib/share';
import cx from 'classnames';

import './ProductMobileShare.scss';

type Props = {
  url: string,
  title: string,
  username: string,
  informCopy: () => void,
};
type State = {
  open: boolean,
};

class ProductMobileShare extends Component<Props, State> {
  state = {
    open: false,
  };

  onToggle = () => {
    this.setState({
      open: !this.state.open,
    });

    const shareButton = document.getElementsByClassName('shareBtn');

    for (let i = 0; i < shareButton.length; i += 1) {
      shareButton[i].classList.toggle('closed');
    }
  };

  onFacebookShare = () => {
    this.onToggle();
    shareFacebook(`${process.env.BASE_URL}${this.props.url}`);
  };

  onTwitterShare = () => {
    this.onToggle();
    shareTwitter(
      `${process.env.BASE_URL}${this.props.url}`,
      `${this.props.username}님이 등록하신 "${this.props.title}" 상품을 둘러보세요.`,
    );
  };

  onCopy = () => {
    // this.onToggle();
    copyText(`${process.env.BASE_URL}${this.props.url}`);
    this.props.informCopy();
  };

  render() {
    const { open } = this.state;

    return (
      <div className="ProductMobileShare">
        <button className={cx('main', 'open', 'shareBtn link')} onClick={this.onCopy}>
          <MdLink />
        </button>
        {/* <button className={cx('main', { open })} onClick={this.onToggle}>
          {this.state.open ? <MdClose /> : <MdShare />}
        </button>
        <div className="btns">
          <button onClick={this.onFacebookShare} className="shareBtn closed facebook">
            <FaFacebookSquare />
          </button>
          <button onClick={this.onTwitterShare} className="shareBtn closed twitter">
            <FaTwitter />
          </button>
          <button onClick={this.onCopy} className="shareBtn closed link">
            <MdLink />
          </button>
        </div> */}
      </div>
    );
  }
}

export default ProductMobileShare;



// WEBPACK FOOTER //
// ./src/components/product/ProductMobileShare/ProductMobileShare.js